import {
    getSweetShopArticleByUid,
    GetSweetShopArticleByUidApiResponseSchema,
} from './get-sweet-shop-article-by-uid';

export {
    GetSweetShopArticleByUidApiResponseSchema,
};

export const SweetShopArticlePageActions = {
    getSweetShopArticleByUid,
};
